import { render, staticRenderFns } from "./menuItem-mobile.vue?vue&type=template&id=8815a254&lang=pug"
import script from "./menuItem-mobile.vue?vue&type=script&lang=coffee"
export * from "./menuItem-mobile.vue?vue&type=script&lang=coffee"
import style0 from "./menuItem-mobile.vue?vue&type=style&index=0&id=8815a254&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports